pageId = 'sns_binds-binds-new'
page = '#' + pageId

$ ->
  $bindForm = $("#{page} form")
  $emailInput = $bindForm.find('input[name="sns_binds_bind[email]"]')
  $passwordInput = $bindForm.find('input[name="sns_binds_bind[password]"]')

  $bindForm.on 'ajax:success', (e, result) ->
    unless result.success
      if result.msg == 'binded'
        simple.dialog.confirm
          content: '该账号已绑定别的微信，需要切换绑定才能继续使用，是否切换？'
          callback: (e, confirm) ->
            if confirm
              $.ajax
                type: 'POST'
                url: '/sns_binds/switch'
                dataType: 'json'
                data: sns_binds_switch:
                  email: $emailInput.val()
                  password: $passwordInput.val()
                success: (result) ->
                  if result.success
                    location.href = result.target_url
